import axios from 'axios'
import store from '@/store'
import useLogger from '@/composables/useLogger'

const logger = useLogger('r4Client')

const R = require('ramda')

const r4Auth = config => {
  return store.dispatch('getCurrentUser')
    .then((user) => {
      const idToken = user.tokens.IdToken
      config.headers.Authorization = `Bearer token="${idToken}"`
      return Promise.resolve(config)
    })
    .catch((error) => {
      logger.trace(error)
      return Promise.resolve(config) // if error, don't decorate and let it fail
    })
}

const r4AuthErrorHandler = error => {
  return Promise.reject(error)
}

const r4Client = (authRequired = true) => {
  const client = axios.create({
    baseURL: process.env.VUE_APP_R4_ENDPOINT
  })
  if (authRequired) {
    client.interceptors.request.use(r4Auth, r4AuthErrorHandler)
  }
  return client
}

export function r4Error (axiosError) {
  if (axiosError.isAxiosError) {
    const msg = R.pathOr(axiosError.message, ['response', 'data', 'data', 'message'], axiosError)
    const statusCode = R.pathOr('???', ['response', 'status'], axiosError)
    const error = new Error(msg)
    error.status = statusCode
    return error
  } else {
    return axiosError
  }
}

export default r4Client
